module.exports = __webpack_public_path__ + "img/loginQuoteImage04.8a2735b0.webp";